const socketWpp = io.connect(`${location.protocol}//${location.hostname}:4000`);

socketWpp.on('connect', () => {
	socketWpp.emit('realtime:join');
});

module.exports = {
	socketWpp
}
